<script setup>
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content } = useMessageContext();
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="cta-url">
    <span v-dompurify-html="content" :title="content" />
  </BaseBubble>
</template>
